/**
 * `/organization/employees` — l'elenco dei dipendenti, come `/erp-employee` di Lares (19-10-2026).
 *
 * La voce «Dipendenti» del menu portava a `/workforce`, che si apre sulla Dashboard di Segreteria
 * & HR: chi cercava una persona trovava dei grafici. Qui c'è l'elenco e basta. `/workforce` resta
 * com'è finché non si decide che fine fa; la tabella è la stessa (`EmployeesTable`).
 *
 * Sul telefono la schermata dei dipendenti è quella di sempre (`MobileWorkforce`).
 */
import { createFileRoute } from '@tanstack/react-router';
import { EmployeesListPage } from '@/features/workforce/EmployeesListPage';
import { MobileWorkforce } from '@/features/workforce/mobile/MobileWorkforce';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/organization/employees')({ component: EmployeesPage });

function EmployeesPage() {
  return useIsMobileShell() ? <MobileWorkforce /> : <EmployeesListPage />;
}
